/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable max-lines-per-function */
/* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/no-explicit-any */
/*
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：検証サービス
 *
 * 作成者：2022/1/6 ノア）黄
 * 最終修正者：2022/1/6 ノア）黄
 *
 */
import { findIndex, findLastIndex, find } from 'lodash'

import { i18n } from '@/locales'

export enum RULES {
  // 英数字のみチェック
  ALPHANUMERIC = 'alphanumeric',
  // 半角英数記号
  ALPHANUMERICANDSYMBOLS = 'alphanumericAndSymbols',
  // パスワード
  PASSWORD = 'password',
  // 数字のみチェック
  NUMERIC = 'number',
  // 小数&負数
  NEGATIVEANDDECIMALNUMBER = 'negativeAndDecimalNumber',
  // 電話番号 電話番号(XXXX-XXXX)
  TEL = 'tel',
  // Eメールチェック
  EMAIL = 'email',
  // 経度
  LONGITUDE = 'lng',
  // 最大長チェック
  MAXLENGTH = 'maxlength',
  // 最小長チェック
  MINLENGTH = 'minlength',
  // 最大最小長チェック
  RANGE = 'range',
  // 重複
  REPEAT = 'repeat',
  // 関連重複
  MUTIPLEREPEAT = 'multipleRepeat',
  // コード変換
  CODECHANGE = 'codeChange',
  // 関連マスタ
  INPARENT = 'inparent',
  // 日付
  DATE = 'date',
  // 最大最小数チェック
  NUMBERRANGE = 'numberRange',
  // 最大小数長
  MAXDECIMALLENGTH = 'maxDecimalLength',
  // 関連
  MUTIPLE = 'multiple',
  // カスタム＃カスタム＃
  CUSTOM = 'custom',
  //sigfoxID
  SIGFOXID = 'sigfoxID',
  // URL
  URL = 'url'
}

export const VALID_PATTERN = {
  // 英数字のみチェック
  [RULES.ALPHANUMERIC]: /^[A-Za-z0-9]+$/,
  // 半角英数記号
  // eslint-disable-next-line
  [RULES.ALPHANUMERICANDSYMBOLS]: /^[A-Za-z0-9\-]+$/,
  // パスワード
  // eslint-disable-next-line
  [RULES.PASSWORD]: /^[A-Za-z0-9\$\#\%\&\.\-\@\?\*]+$/,
  // 数字のみチェック
  [RULES.NUMERIC]: /^\d+$/,
  // 電話番号 電話番号(XXXX-XXXX)
  [RULES.TEL]: /^([0-9]{1,20}-){1,5}[0-9]{1,20}$/,
  // Eメールチェック
  // eslint-disable-next-line
  [RULES.EMAIL]: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  // 日付
  [RULES.DATE]: /^((?:19|20)\d\d)\/(0[1-9]|1[012])\/(0[1-9]|[12][0-9]|3[01])$/,
  // 小数&負数
  // eslint-disable-next-line
  [RULES.NEGATIVEANDDECIMALNUMBER]: /-?(0|[1-9]\d*)(\.\d+)?$/,
  // 経度
  // eslint-disable-next-line
  [RULES.LONGITUDE]: /^[\-\+]?(0(\.\d{1,10})?|([1-9](\d)?)(\.\d{1,10})?|1[0-7]\d{1}(\.\d{1,10})?|(180\.0{1,10})|180)$/,
  // sigfoxID
  // eslint-disable-next-line
  [RULES.SIGFOXID]: /^[A-Za-z0-9\-]{8}(,[A-Za-z0-9\-]{8})*$/,
  // URL
  // eslint-disable-next-line
  [RULES.URL]: /^https?:\/\/([\w.-]+)(:\d+)?(\/[^\s]*)?$/
}

export interface ValidateParams {
  rule: RULES
  message?: string
  csvMessage?: string
  messageEnterPoint?: string[] // メッセージエントリポイント(csv用)
  number?: number
  range?: number[]
  tableData?: any[]
  visableTableData?: () => any[]
  tableColumn?: string
  masterData?: any[]
  masterLayoutName?: string
  masterParentLayoutName?: string
  masterParentKey?: string
  childrenListKey?: string
  multipleRepeatKeyList?: string[]
  callback?: any
  isDisabled?: any
}

export interface CsvRule {
  required?: boolean
  pattern?: RegExp
  validRule?: Array<ValidateParams>
  csvMessage: string
  messageEnterPoint?: string[]
  csvIgnore?: boolean
}

/**
 *
 * @class
 */
class ValidateService {
  /**
   * 検証FUNCを取得する
   *
   * @param {ValidateParams} params パラメータ
   * @returns {void}
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getValidator(params: Array<ValidateParams>): (ruleName: RULES, value: string, callback: any) => void {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.validate = (rule: any, value: string, callback: any): void => {
      let first = 0
      let last = 0
      for (const param of params) {
        switch (param.rule) {
          case RULES.MAXLENGTH:
            if (!value) {
              break
            }

            if (value.length > (param.number || 0)) {
              callback(new Error(param.message))
              return
            }
            break
          case RULES.MINLENGTH:
            if (!value) {
              break
            }

            if (value.length < (param.number || 0)) {
              callback(new Error(param.message))
              return
            }
            break
          case RULES.RANGE:
            if (!param || !param.range || param.range.length !== 2) {
              break
            }

            if (value.length < param.range[0] || value.length > param.range[1]) {
              callback(new Error(param.message))
              return
            }
            break
          case RULES.NUMBERRANGE:
            if (!param || !param.range || param.range.length !== 2) {
              break
            }

            if (!value && parseFloat(value) !== 0) {
              callback(new Error(param.message))
              return
            }

            if (isNaN(parseFloat(value)) || parseFloat(value) < param.range[0] || parseFloat(value) > param.range[1]) {
              callback(new Error(param.message))
              return
            }
            break
          case RULES.REPEAT:
            if (!value) {
              break
            }

            if (!param || !param.tableData || !param.tableColumn) {
              break
            }

            if (param.visableTableData && param.isDisabled) {
              const visableTableData = param.visableTableData()
              const currentRowIndex = this.getCurrentRowIndex(rule)
              const currentRow = visableTableData[currentRowIndex]
              if (currentRow && param.isDisabled(currentRow)) {
                break
              }
            }

            // @ts-ignore
            first = findIndex(param.tableData, (item: any) => item[param.tableColumn] === value)
            if (first < 0) {
              break
            }

            // @ts-ignore
            last = findLastIndex(param.tableData, (item: any) => item[param.tableColumn] === value)
            if (first !== last) {
              callback(new Error(param.message))
              return
            }
            break
          case RULES.MAXDECIMALLENGTH:
            if (!value || !param.number) {
              break
            }

            const splited = value.toString().split('.')
            if (splited.length < 2) {
              break
            }

            const decimal = splited[1]

            if (decimal.length > param.number) {
              callback(new Error(param.message))
              return
            }
            break

          case RULES.MUTIPLE:
            if (!value) {
              break
            }

            if (!param.callback) {
              break
            }

            const message = param.callback(value)
            if (message) {
              callback(new Error(message))
              return
            }

            break

          case RULES.CUSTOM:
            if (!param.callback) {
              break
            }

            const custom_message = param.callback(value, rule)
            if (custom_message) {
              callback(new Error(custom_message))
              return
            }

            break
          default:
            callback()
        }
      }
      callback()
    }

    return this.validate
  }

  /**
   * 検証を行う
   *
   * @param {string} ruleName 検証ルール名
   * @param {string} value 検証対象の値
   * @param {any} callback コールバック
   * @returns {void}
   */
  // eslint-disable-next-line
  validate(ruleName: string, value: string, callback: any): void { }

  /**
   * CSV検証を行う
   *
   * @param {Array<any>} csvData CSVデータ
   * @param {any} allRules ルール
   * @param {Array<any>} tableData テーブルデータ
   * @param {number} indexOffset 開始行のoffset
   * @returns {any} エラーメッセージリストと正当データリスト
   */
  csvValidate(csvData: Array<any>, allRules: any, tableData: Array<any>, indexOffset: number): any {
    const messageList = []
    const validData = []
    for (let i = 0; i < csvData.length; i++) {
      let rowErr = false
      let first = 0
      let last = 0
      const row = csvData[i]
      const keys = Object.keys(allRules)
      for (const key of keys) {
        const rules = allRules[key] as Array<CsvRule>
        const value = row[key]
        for (const rule of rules) {
          if (rule.csvIgnore) {
            continue
          }

          // 必須
          if (rule.required) {
            if (!value) {
              const message = this.getCsvValidateMessage(i + indexOffset, rule.csvMessage, rule.messageEnterPoint)
              messageList.push(message)
              rowErr = true
            }
          }

          // 正規表現
          if (rule.pattern) {
            if (!value) {
              break
            }

            if (!rule.pattern.test(value)) {
              const message = this.getCsvValidateMessage(i + indexOffset, rule.csvMessage, rule.messageEnterPoint)
              messageList.push(message)
              rowErr = true
            }
          }

          // 検証
          if (rule.validRule) {
            for (const validRule of rule.validRule) {
              let masterData: any
              let parentValue: any
              switch (validRule.rule) {
                case RULES.MAXLENGTH:
                  if (!value) {
                    break
                  }

                  if (value.length > (validRule.number || 0)) {
                    const message = this.getCsvValidateMessage(
                      i + indexOffset,
                      validRule.csvMessage || '',
                      validRule.messageEnterPoint
                    )
                    messageList.push(message)
                    rowErr = true
                    break
                  }
                  break
                case RULES.MINLENGTH:
                  if (!value) {
                    break
                  }

                  if (value.length < (validRule.number || 0)) {
                    const message = this.getCsvValidateMessage(
                      i + indexOffset,
                      validRule.csvMessage || '',
                      validRule.messageEnterPoint
                    )
                    messageList.push(message)
                    rowErr = true
                    break
                  }
                  break
                case RULES.RANGE:
                  if (!value) {
                    break
                  }

                  if (!validRule.range || validRule.range.length !== 2) {
                    break
                  }

                  if (value.length < validRule.range[0] || value.length > validRule.range[1]) {
                    const message = this.getCsvValidateMessage(
                      i + indexOffset,
                      validRule.csvMessage || '',
                      validRule.messageEnterPoint
                    )
                    messageList.push(message)
                    rowErr = true
                  }
                  break
                case RULES.NUMBERRANGE:
                  if (!value) {
                    return
                  }

                  if (!validRule.range || validRule.range.length !== 2) {
                    break
                  }

                  if (
                    isNaN(parseFloat(value)) ||
                    parseFloat(value) < validRule.range[0] ||
                    parseFloat(value) > validRule.range[1]
                  ) {
                    const message = this.getCsvValidateMessage(
                      i + indexOffset,
                      validRule.csvMessage || '',
                      validRule.messageEnterPoint
                    )
                    messageList.push(message)
                    rowErr = true
                  }
                  break
                case RULES.REPEAT:
                  if (!value) {
                    break
                  }

                  if (!tableData || !validRule.tableColumn) {
                    break
                  }

                  if (0 <= findIndex(tableData, (item: any) => item[key] === value)) {
                    const message = this.getCsvValidateMessage(
                      i + indexOffset,
                      validRule.csvMessage || '',
                      validRule.messageEnterPoint
                    )
                    messageList.push(message)
                    rowErr = true
                  }

                  first = findIndex(csvData, (item: any) => item[key] === value)
                  last = findLastIndex(csvData, (item: any) => item[key] === value)
                  if (first !== last) {
                    const message = this.getCsvValidateMessage(
                      i + indexOffset,
                      validRule.csvMessage || '',
                      validRule.messageEnterPoint
                    )
                    messageList.push(message)
                    rowErr = true
                  }

                  break
                case RULES.CODECHANGE:
                  if (!value) {
                    break
                  }

                  if (!validRule.masterData || validRule.masterData.length === 0 || !validRule.masterLayoutName) {
                    break
                  }

                  // @ts-ignore
                  masterData = find(validRule.masterData, (item: any) => item[validRule.masterLayoutName] === value)
                  if (!masterData) {
                    const message = this.getCsvValidateMessage(
                      i + indexOffset,
                      validRule.csvMessage || '',
                      validRule.messageEnterPoint
                    )
                    messageList.push(message)
                    rowErr = true
                    break
                  }

                  break
                case RULES.INPARENT:
                  if (!value) {
                    break
                  }

                  if (
                    !validRule.masterData ||
                    validRule.masterData.length === 0 ||
                    !validRule.masterLayoutName ||
                    !validRule.masterParentLayoutName ||
                    !validRule.masterParentKey ||
                    !validRule.childrenListKey
                  ) {
                    break
                  }

                  parentValue = row[validRule.masterParentKey]
                  // @ts-ignore
                  // eslint-disable-next-line prettier/prettier
                  masterData = find(validRule.masterData, (item: any) => item[validRule.masterParentLayoutName] === parentValue)
                  if (!masterData) {
                    break
                  }

                  masterData = masterData[validRule.childrenListKey]
                  if (!masterData || masterData.length === 0) {
                    const message = this.getCsvValidateMessage(
                      i + indexOffset,
                      validRule.csvMessage || '',
                      validRule.messageEnterPoint
                    )
                    messageList.push(message)
                    rowErr = true
                    break
                  }

                  // @ts-ignore
                  masterData = find(masterData, (item: any) => item[validRule.masterLayoutName] === value)
                  if (!masterData) {
                    const message = this.getCsvValidateMessage(
                      i + indexOffset,
                      validRule.csvMessage || '',
                      validRule.messageEnterPoint
                    )
                    messageList.push(message)
                    rowErr = true
                    break
                  }

                  break
                case RULES.MUTIPLEREPEAT:
                  if (
                    !validRule.tableData ||
                    validRule.tableData.length === 0 ||
                    !validRule.multipleRepeatKeyList ||
                    validRule.multipleRepeatKeyList.length === 0
                  ) {
                    break
                  }

                  const getMultipleValue = (rowData: any) => {
                    let multipleValue = ''
                    if (!validRule || !validRule.multipleRepeatKeyList) {
                      return multipleValue
                    }

                    validRule.multipleRepeatKeyList.forEach(key => {
                      multipleValue += rowData[key]
                    })
                    return multipleValue
                  }

                  const multipleValue = getMultipleValue(row)

                  if (0 <= findIndex(tableData, (item: any) => getMultipleValue(item) === multipleValue)) {
                    const message = this.getCsvValidateMessage(
                      i + indexOffset,
                      validRule.csvMessage || '',
                      validRule.messageEnterPoint
                    )
                    messageList.push(message)
                    rowErr = true
                  }

                  first = findIndex(csvData, (item: any) => getMultipleValue(item) === multipleValue)
                  last = findLastIndex(csvData, (item: any) => getMultipleValue(item) === multipleValue)
                  if (first !== last) {
                    const message = this.getCsvValidateMessage(
                      i + indexOffset,
                      validRule.csvMessage || '',
                      validRule.messageEnterPoint
                    )
                    messageList.push(message)
                    rowErr = true
                  }

                  break
                case RULES.MAXDECIMALLENGTH:
                  if (!value || !validRule.number) {
                    break
                  }

                  const splited = value.toString().split('.')
                  if (splited.length < 2) {
                    break
                  }

                  const decimal = splited[1]

                  if (decimal.length > validRule.number) {
                    const message = this.getCsvValidateMessage(
                      i + indexOffset,
                      validRule.csvMessage || '',
                      validRule.messageEnterPoint
                    )
                    messageList.push(message)
                    rowErr = true
                  }
                  break
                case RULES.MUTIPLE:
                  if (!value) {
                    break
                  }

                  if (!validRule.callback) {
                    break
                  }

                  const message = validRule.callback(key, row, i + indexOffset)
                  if (message) {
                    messageList.push(message)
                    rowErr = true
                  }

                  break
                default:
                  break
              }
            }
          }
        }
      }

      if (!rowErr) {
        validData.push(row)
      }
    }

    return {
      messageList,
      validData
    }
  }

  /**
   * 検証結果のメッセージを取得する
   *
   * @param {number} rowIndex 行インデックス
   * @param {string} messages メッセージ
   * @param {Array<string> | undefined} messageEnterPoint メッセージ入力先
   * @returns {string} 検証結果のメッセージ
   */
  getCsvValidateMessage(rowIndex: number, messages: string, messageEnterPoint: Array<string> | undefined): string {
    if (!messageEnterPoint) {
      return i18n.t(messages, rowIndex.toString()).toString()
    } else {
      return i18n.t(messages, [rowIndex.toString(), ...messageEnterPoint]).toString()
    }
  }

  /**
   * 当前検証項目の行を取得する
   *
   * @param {any} rule 検証項目
   * @returns {number} 当前行
   */
  getCurrentRowIndex(rule: any): number {
    const { field } = rule
    if (!field) {
      return -1
    }

    const target = /tableData\[([0-9]*)\].\w+/.exec(field)
    if (!target || target.length < 2) {
      return -1
    }

    return Number(target[1])
  }

  /**
   * パスワードの複雑さを検証する
   *
   * @param {string} value パスワード
   * @returns {boolean} 検証結果
   */
  passwordComplexityValidate(value: string): boolean {
    if (!value) {
      return true
    }

    let count = 0
    // 英字
    if (/[a-zA-Z]+/.test(value)) {
      count++
    }

    // 数字
    if (/[0-9]+/.test(value)) {
      count++
    }

    // 記号
    if (/[-$#%.@?*]+/.test(value)) {
      count++
    }

    // ２種類以上
    if (count >= 2) {
      return true
    }

    return false
  }
}

// export as singleton
export const validateService = new ValidateService()
